export const useExternalLink = (url) => {
  const openLink = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return openLink;
};